var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.18 9.47-7.67-7.68A2.64 2.64 0 0 0 8.7 1H3.5A2.53 2.53 0 0 0 1 3.5v5.2a2.64 2.64 0 0 0 .79 1.81l7.7 7.7a2.64 2.64 0 0 0 1.81.79 2.64 2.64 0 0 0 1.81-.79l5.13-5.14a2.28 2.28 0 0 0 .8-1.72 2.52 2.52 0 0 0-.86-1.88Zm-1.29 2.12-5.2 5.2a.46.46 0 0 1-.78 0l-7.7-7.7A.6.6 0 0 1 3 8.7V3.5a.54.54 0 0 1 .5-.5h5.2a.6.6 0 0 1 .39.21l7.7 7.7.06.05a.51.51 0 0 1 .19.37.32.32 0 0 1-.15.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1.5
  }))));
};
export default SvgTag;